import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { TranslateDirective } from './translate.directive';
import { TranslateService } from './translate.service';
import { TranslatePipe, TranslateImpurePipe } from './translate.pipe';

export { TranslateDirective } from './translate.directive';
export { TranslateService } from './translate.service';
export { TranslatePipe, TranslateImpurePipe } from './translate.pipe';

@NgModule({
  declarations: [
    TranslateDirective,
    TranslatePipe,
    TranslateImpurePipe
  ],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [
    TranslateDirective,
    TranslatePipe,
    TranslateImpurePipe
  ],
  providers: [
    TranslateService,
    TranslatePipe,
    TranslateImpurePipe
  ],
})
export class TranslateModule {}
